import type { Space } from '@cocoonspace/sdk-js/types/space'

interface RecurringSpacePriceParams {
	billedHours: number
	space: Pick<Space, 'prices'>
	rebate: number
	daysPerWeek: number
	label?: 'hours' | 'days'
}

const getRoundedRecurringSpacePrice = (
	v: number,
	label: RecurringSpacePriceParams['label'],
) => (label === 'days' ? Math.ceil(v / 100) * 100 : Math.floor(v / 100) * 100)

export const recurringSpacePrice = ({
	billedHours,
	space,
	rebate,
	daysPerWeek,
	label = 'hours',
}: RecurringSpacePriceParams) => {
	const ogPrice =
		getRoundedRecurringSpacePrice(
			(billedHours * space.prices?.weekday_max?.hour_standard! * 52) / 12,
			label,
		) * daysPerWeek

	const rebatedPrice = getRoundedRecurringSpacePrice(
		ogPrice * (1 - rebate),
		label,
	)

	return { ogPrice, recurringPrice: rebatedPrice }
}
